module.exports = __webpack_public_path__ + "static/media/real-estate-house.1acebc2b.svg";